import React from 'react';
import { Plus, Zap } from 'lucide-react';

interface EmptyChildrenStateProps {
  onWizardClick: () => void;
  onAddChildClick: () => void;
}

export function EmptyChildrenState({ onWizardClick, onAddChildClick }: EmptyChildrenStateProps) {
  return (
    <div className="text-center py-16">
      <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <Plus className="w-12 h-12 text-gray-400" />
      </div>
      <h2 className="text-2xl font-bold text-gray-900 mb-4 font-baloo">No Children Added Yet</h2>
      <p className="text-gray-600 mb-8 max-w-md mx-auto">
        Start by adding your first child to begin tracking their learning journey and progress.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
        <button
          onClick={onWizardClick}
          className="inline-flex items-center space-x-2 px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all shadow-lg text-lg font-baloo"
        >
          <Zap className="w-6 h-6" />
          <span>Quick Start Wizard</span>
        </button>
        <button
          onClick={onAddChildClick}
          className="inline-flex items-center space-x-2 px-8 py-4 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-colors shadow-lg text-lg font-baloo"
        >
          <Plus className="w-6 h-6" />
          <span>Add Child Only</span>
        </button>
      </div>
    </div>
  );
}
